import BadgeEstados from "../../../../../components/BadgeEstado";

const Properties = ({ properties }) => {
  return (
    <>
      <section>
        <h4 className="m-0">Propiedades</h4>
        <div className="row">
          <div className="col">
            {properties.old && (
              <div>
                <h5 className="m-0">Antes</h5>
                <div>
                  {Object.entries(properties.old).map(([key, value]) => (
                    <div
                      key={key}
                      style={{ marginBottom: "10px" }}
                      className="d-flex flex-column gap-1"
                    >
                      {key == "estado_id" && (
                        <div style={{ width: "fit-content" }}>
                          <BadgeEstados estado_id={value} />
                        </div>
                      )}
                      <div className="d-flex gap-2 bg-danger px-3 text-wrap overflow-scroll">
                        <h5 className="text-white m-0">{key}: </h5>
                        <h5 className="text-white m-0"> {value}</h5>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className="col">
            {properties.attributes && (
              <div>
                <h5 className="m-0">Ahora</h5>
                <div>
                  {Object.entries(properties.attributes).map(([key, value]) => (
                    <div
                      key={key}
                      style={{ marginBottom: "10px" }}
                      className="d-flex flex-column gap-1"
                    >
                      {key == "estado_id" && (
                        <div style={{ width: "fit-content" }}>
                          <BadgeEstados estado_id={value} />
                        </div>
                      )}
                      <div className="d-flex gap-2 bg-success px-3 text-wrap overflow-scroll">
                        <h5 className="text-white m-0">{key}: </h5>
                        <h5 className="text-white m-0"> {value}</h5>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};
export default Properties;
